import { render, staticRenderFns } from "./AddSubject.vue?vue&type=template&id=64d6db5d&scoped=true&"
import script from "./AddSubject.vue?vue&type=script&lang=js&"
export * from "./AddSubject.vue?vue&type=script&lang=js&"
import style0 from "./AddSubject.vue?vue&type=style&index=0&id=64d6db5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6db5d",
  null
  
)

export default component.exports